/* global $, Modernizr */

const $navigation = $('.js-navigation');
const $dropdown = $('.js-nav-dropdown-search');
const $searchToggler = $('.js-nav-search');

const SEARCH_FOCUS_DELAY = 300;

function getIcon(name) {
  return `
    <svg class='icon icon-${name}' aria-hidden='true'>
      <use xlink:href='#icon-${name}'></use>
    </svg>
  `;
}

const navigation = {
  initialize() {
    $(window).on('load', () => {
      $('.js-nav-dropdown-container').removeAttr('style');
    });

    if ($navigation.length) {
      this.createEvents();
    }
  },

  createEvents() {
    if (Modernizr.mq('(max-width: 991px)')) {
      $navigation.find('.nav-item.has-dropdown > a').on('click', (e) => {
        e.preventDefault();

        this.toggleDropdown($(e.currentTarget).parent());
      });
    }

    $searchToggler.on('click', () => {
      const $input = $dropdown.find('.js-search-input');
      const isOpen = $dropdown.hasClass('is-open');

      this.toggleSearch($input, isOpen);
    });
  },

  toggleSearch(input, isOpen) {
    if (!isOpen) {
      setTimeout(
        () => {
          if (input) {
            input.focus();
          }
        },
        SEARCH_FOCUS_DELAY,
      );
    }

    $searchToggler.html(isOpen ? getIcon('search') : getIcon('close'));

    $dropdown.toggleClass('is-open');
  },

  toggleDropdown($target) {
    const isOpen = $target.find('.nav-dropdown').hasClass('is-open');
    const items = $target.find('.nav-dropdown > .nav-dropdown__item').toArray();

    const height = items.reduce((prev, now) => (
      prev + $(now).outerHeight()
    ), 0);

    $target
      .find('.nav-dropdown')
      .toggleClass('is-open')
      .css('height', isOpen ? 0 : height);
  },
};

export default navigation;
